const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.97 4.24a1.003 1.003 0 00-1.71-.71l-6.29 6.29-6.29-6.29a1.003 1.003 0 00-1.42 1.42l7 7c.01.01.01.01.02.01.09.08.19.15.3.2.12.05.25.08.38.08a.995.995 0 00.7-.3l7-7c.2-.17.31-.42.31-.7z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.97 12.16a1.003 1.003 0 00-1.71-.71l-6.29 6.29-6.29-6.29a1.003 1.003 0 00-1.42 1.42l7 7c.01.01.01.01.02.01.09.08.19.15.3.2.12.05.25.08.38.08a.995.995 0 00.7-.3l7-7c.2-.18.31-.43.31-.7z"
});

const SvgOpenAll = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpenAll, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/open-all.6f734841.svg";
export { ForwardRef as ReactComponent };